import { useOktaAuth } from "@okta/okta-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import OrdersListResponse from "../../models/API/responseModels/ordersListResponse.model";
import OrderDetailResponse from "../../models/API/responseModels/onlineOrderResponseModels/orderDetailResponse.model";
import physicianToClinician from "../helpers/physicianToClinician";

function transformResponse(res: string) {
  let response = JSON.parse(res);
  if (response?.data?.orders?.length > 0) {
    response = {
      ...response,
      data: {
        ...response.data,
        orders: response.data.orders.map((order: OrderDetailResponse) => ({
          ...order,
          patient: `${order.patientFirstName} ${order.patientLastName}`,
          testTypeCode: `${order.testTypes.id}`,
          castleId: !!order?.castleId ? order.castleId : "NA",
          specimenId: !!order?.specimenId ? order.specimenId : "NA",
          orderDate: !!order?.orderDate ? order.orderDate : "NA",
          reportReadyDate: !!order?.reportReadyDate ? order.reportReadyDate : "NA",
          castleResult: !!order?.castleResult ? order.castleResult : "NA",
          placedBy: physicianToClinician(order?.placedBy),
        })),
      },
    };
  }
  return response;
}

export function useTestOrdersByIds({
  ids,
  skipPagination = true,
}: {
  ids: string[];
  skipPagination?: boolean;
}): UseQueryResult<OrdersListResponse> {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: ["testOrdersByIds", ids, skipPagination],
    queryFn: () => {
      // Build the params string exactly like the original hook expects
      const params = `?ids=${ids.join(",")}&skipPagination=${skipPagination}`;
      
      return axiosInstance
        .get(
          `/v1/orders/new-flow${params}`,
          {
            headers: {
              Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
            },
            transformResponse,
          }
        )
        .then((res) => {
          return res.data;
        });
    },
    enabled: !!ids?.length && !!authState?.accessToken?.accessToken,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    retry: false,
  });
}